import { render, staticRenderFns } from "./AddRestaurant.vue?vue&type=template&id=5db265c3"
import script from "./AddRestaurant.vue?vue&type=script&lang=js"
export * from "./AddRestaurant.vue?vue&type=script&lang=js"
import style0 from "./AddRestaurant.vue?vue&type=style&index=0&id=5db265c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports